import {
  IconCircleCheck,
  IconCircleDashed,
  IconCheck,
  IconAlertCircle,
  IconInfoCircle,
} from '@tabler/icons-react'
import { Moment } from 'moment'

import { FileUploadResult } from '@/hooks/useDocumentUpload'

import { ToolboxStatus, ToolboxType } from 'types/api.graphql'

export const TAB_INFORMATION = 'Information'
export const TAB_ATTENDEES = 'Attendees'
export const TAB_ATTACHMENTS = 'Attachments'

export const TOOLBOX_TABS = {
  information: TAB_INFORMATION,
  attendees: TAB_ATTENDEES,
  attachments: TAB_ATTACHMENTS,
}

export const TOOLBOX_STATUS_STATUSES = {
  [ToolboxStatus.Completed]: {
    label: 'Completed',
    value: ToolboxStatus.Completed,
    icon: <IconCircleCheck size={16} />,
    variant: 'success' as const,
  },
  [ToolboxStatus.Distributed]: {
    label: 'Invitations Sent',
    value: ToolboxStatus.Distributed,
    icon: <IconCheck size={16} />,
    variant: 'info' as const,
  },
  [ToolboxStatus.Draft]: {
    label: 'Draft',
    value: ToolboxStatus.Draft,
    icon: <IconCircleDashed size={16} />,
    variant: 'warning' as const,
  },
}

export const TOOLBOX_TYPE_STATUSES = {
  [ToolboxType.Regular]: {
    label: 'Regular',
    value: ToolboxType.Regular,
    variant: undefined,
  },
  [ToolboxType.Incident]: {
    label: 'Incident',
    value: ToolboxType.Incident,
    icon: <IconAlertCircle size={16} />,
    variant: 'danger' as const,
  },
  [ToolboxType.Other]: {
    label: 'Other',
    value: ToolboxType.Incident,
    icon: <IconInfoCircle size={16} />,
    variant: 'info' as const,
  },
}

export enum Field {
  Date = 'date',
  Type = 'type',
  Agenda = 'agenda',
  Files = 'files',
  Notes = 'notes',
}

export type FormFieldValues = {
  [Field.Date]: Moment
  [Field.Type]: ToolboxType
  [Field.Agenda]: string
  [Field.Files]: FileUploadResult[]
  [Field.Notes]: string
}
